export default "{\n    \"chipLabel\": \"NOUVEAU\"\n}\n"